<template>
  <div class="modal" :class="{'is-active': modelValue === true}">
    <div class="modal-background" @click="modelValue = false"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="column">
          <div class="modal-card-title">
            <slot name="header" />
          </div>
        </div>
        <button class="button closer" @click="modelValue = false">
          <span class="icon-cross"></span>
        </button>
      </header>
      <div class="modal-card-body">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  }
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value: boolean) {
    emit('update:modelValue', value);
  }
});
</script>

<style scoped>

</style>
